import request from "./../utils/request";

export async function getProductList(payload) {
  return request.get("Product/List", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      categoryId: payload.category ? payload.category.id : null,
      productId: payload.product ? payload.product.id : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    },
  });
}
export async function createNewProduct(newProduct) {
  return request.post("Product/Create", newProduct);
}
export async function updateProduct(product) {
  return request.post("Product/Update", product);
}
export async function createNewVariant(newVariant) {
  return request.post("Product/VarCreate", newVariant);
}
export async function updateVariant(variant) {
  return request.post("Product/VarUpdate", variant);
}
export async function deleteProduct(id) {
  return request.delete("Product/Delete?id=" + id);
}
export async function getProductByIdForIntegration(id) {
  return request.get("Product/GetProductByIdForIntegration?productId=" + id);
}
export async function getProductById(id) {
  return request.get("Product/GetById?productId=" + id);
}
export async function getProductNameList() {
  return request.get("Product/NameList");
}
export async function getRecipeList(recipeId) {
  return request.get("Recipe/available?recipeId=" + recipeId);
}
export async function getUnitList() {
  return request.get("Unit/List");
}
export async function getReciplessProductNameList() {
  return request.get("Product/ReciplessNameList");
}
export async function getExtralessProductNameList() {
  return request.get("Product/ExtralessNameList");
}
export async function getAllActiveChilds() {
  return request.get("Product/GetAllActiveChilds");
}
export async function uploadImage(image) {
  return request({
    method: "post",
    url: "UploadImage/",
    data: image,
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === "object"
          ? serialize(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v)
      );
    }
  }
  return str.join("&");
}
